import moment from 'moment'
export const timeSchedule = item =>{
    // return `${moment(item.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("HH:mm")} - ${moment(item.dateTimeEnd, "YYYY-MM-DDTHH:mm:ss").format("HH:mm")} ${item.tipoModalidadAtencion}`
    return `${moment(item.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("HH:mm")} - ${moment(item.dateTimeEnd, "YYYY-MM-DDTHH:mm:ss").format("HH:mm")}`
}